import logo from '../../../images/png/logo.png'
import DialButton from '../../../Components/DialButton'
import './Start.css'

const Start = ({ nextPage }) => {

    return (
        <div className='flex start-container'>
            <img className='start-logo' src={logo} alt="" />
            <div className="start-slogan">Taivuttele tai tule taivutelluksi</div>
            <div className="start-creators">Haaga, Kalenius, Kinnunen, Pessi, Seppänen, Vakkala</div>
            <div className='start-button-phone-container'
                onClick={() => nextPage()}>
                <DialButton type='answer' />
            </div>
        </div>
    )
}

export default Start